<template>
  <div class="search-index">
    <div class="top-search clearfix">
      <div class="sec-left fl">
        <span @click="goHome" class="n-back"></span>
      </div>
      <input
        type="text"
        :placeholder="$t('search.search')"
        v-model="key"
        @keypress="press"
        @blur="temporaryRepair"
      />
      <div class="sec-right sec-submit fr" @click="search"></div>
      <span class="clear-input" @click="clearInput"></span>
    </div>
    <div class="fix-view">
      <router-view />
    </div>
  </div>
</template>
<script>
export default {
  name: "SearchIndex",
  data() {
    return {
      key: "",
      typingTimer: null, // 延时器
      typingInterval: 2000,
    };
  },
  computed: {
    changeKey() {
      return this.$store.state.searchWord;
    },
  },
  watch: {
    changeKey(newVal) {
      this.key = newVal;
    },
  },
  created() {
    this.key = this.$store.state.searchWord;
  },
  methods: {
    search() {
      this.$store.commit("changeWord", this.key);
      this.addHistory();
      if (this.$store.state.searchNav == 0) {
        this.$router.push({ path: "/searchIndex/mainSearch/resources" });
      }
    },
    // 添加历史搜索
    addHistory() {
      let url = "index.php/mobile/search/add-history";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: 5,
        language: localStorage.getItem("_user_data_language"),
        keyword: this.key,
        type: 1,
        // client_version:'1.2.0'
      };
      this.$axios.post(url, params).then();
    },
    keyUp() {
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(this.typing, this.typingInterval);
    },
    keyDown() {
      clearTimeout(this.typingTimer);
    },
    typing() {
      // console.log("输入1秒后执行")
      this.$store.commit("changeWord", this.key);
    },
    press(event) {
      if (event.keyCode === 13) {
        // 回车
        clearTimeout(this.typingTimer);
        this.search();
      }
    },
    clearInput() {
      this.$store.commit("changeWord", "");
    },
    goHome() {
      setTimeout(() => {
        window.scrollTo(0, 0); // 页面向上滚动
        this.$router.replace({ path: "/main/index" });
      }, 1);
    },
    // ios软键盘恢复
    temporaryRepair() {
      // var currentPosition, timer
      // var speed = 1// 页面滚动距离
      var timer;
      timer = setInterval(function () {
        // currentPosition = document.documentElement.scrollTop || document.body.scrollTop
        // currentPosition -= speed
        window.scrollTo(0, 0); // 页面向上滚动
        // currentPosition+=speed; //speed变量
        // window.scrollTo(0,currentPosition);//页面向下滚动
        clearInterval(timer);
      }, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.search-index {
  background: #eeeeee;
  display: flex;
  flex-direction: column;
  .top-search {
    width: 100vw;
    height: 6vh;
    min-height: 32px;
    background: #f7f7f7;
    display: flex;
    align-items: center;
    padding: 0.14rem 0 0.14rem 0.3rem;
    box-sizing: border-box;
    input {
      width: 5.14rem;
      height: 0.5rem;
      line-height: 0.5rem;
      background-color: white;
      border: none;
      border-radius: 0.25rem;
      text-indent: 0.25rem;
      font-size: 14px;
      outline: none;
      color: #333333;
      margin: 0 0.5rem 0 0.68rem;
      &::-webkit-input-placeholder {
        color: #b5b5b5;
      }
    }
    .sec-submit {
      width: 0.26rem;
      height: 0.26rem;
      background-size: 100% 100%;
      background-image: url(../assets/img/search_icon.png);
      cursor: pointer;
    }
    .sec-left {
      width: 0.18rem;
      height: 0.34rem;
      .n-back {
        display: block;
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
        background-image: url("../assets/img/new/prev.png");
      }
    }
  }
  .fix-view {
    height: 94vh;
  }
  .clear-input {
    position: absolute;
    right: 19vw;
    width: 0.24rem;
    height: 0.24rem;
    background: url("../assets/img/clsicon.png") no-repeat center/contain;
  }
}
</style>
